import React from 'react';
import {
  Box,
  Button,
  Chip,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  Stack,
  Typography,
} from '@mui/material';
import {
  AccountCircle as AccountCircleIcon,
  CheckCircle as CheckCircleIcon,
  Logout as LogoutIcon,
  WarningAmber as WarningAmberIcon,
} from '@mui/icons-material';
import { useAuth } from '../../auth/AuthContext';
import GitHubSettingsPanel from './GitHubSettingsPanel';

const AccountProfileModal = ({ open, onClose }) => {
  const { user, logout } = useAuth();
  if (!user) return null;

  const handleLogout = async () => {
    await logout();
    onClose();
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>
        <Stack direction="row" spacing={1.25} alignItems="center">
          <AccountCircleIcon color="primary" />
          <Box>
            <Typography variant="h6" sx={{ fontWeight: 800 }}>
              Account profile
            </Typography>
            <Typography variant="body2" color="text.secondary">
              {user.first_name} {user.last_name}
            </Typography>
          </Box>
        </Stack>
      </DialogTitle>
      <DialogContent dividers>
        <Stack spacing={3}>
          <Box>
            <Typography variant="subtitle2" sx={{ fontWeight: 800, mb: 1 }}>
              User account
            </Typography>
            <Stack spacing={1}>
              <Typography variant="body2">
                <strong>Email:</strong> {user.email}
              </Typography>
              <Typography variant="body2">
                <strong>Role:</strong> {user.role || 'learner'}
              </Typography>
              <Stack direction="row" spacing={1} alignItems="center">
                <Chip
                  size="small"
                  icon={user.email_verified ? <CheckCircleIcon /> : <WarningAmberIcon />}
                  label={user.email_verified ? 'Email verified' : 'Email not verified'}
                  color={user.email_verified ? 'success' : 'warning'}
                  variant="outlined"
                />
                {user.account_status && (
                  <Chip size="small" label={user.account_status} variant="outlined" />
                )}
              </Stack>
            </Stack>
          </Box>

          <Divider />

          <GitHubSettingsPanel framed={false} />
        </Stack>
      </DialogContent>
      <DialogActions sx={{ px: 3, py: 2, justifyContent: 'space-between' }}>
        <Button color="error" startIcon={<LogoutIcon />} onClick={handleLogout}>
          Sign out
        </Button>
        <Button variant="contained" onClick={onClose}>
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AccountProfileModal;
